module.exports = __webpack_public_path__ + "media/images/blue-rectangle-f7870209887d1580a037a5265eb99b57.png";